/**
 * Admin gate — separate email/password verification for /admin/* routes.
 *
 * Reads expected credentials from env (REACT_APP_ADMIN_EMAIL,
 * REACT_APP_ADMIN_PASSWORD). When the env vars are missing, a safe dev
 * default is used so the panel is reachable in local builds — but the
 * AdminLogin screen surfaces a visible warning so it's never accidentally
 * shipped to production.
 *
 * The gate is stored in `sessionStorage` so closing the tab logs the
 * admin out automatically. The flag is independent of the regular user
 * `AuthContext`, but both are required: the user must also be flagged
 * `role === "admin"` (or be the bootstrap admin) to enter the panel.
 */
const STORAGE_KEY = "neyra.adminGate";

const DEFAULT_EMAIL = "admin@neyra.app";
const DEFAULT_PASSWORD = "Admin@2025!";

const expectedEmail = (
    process.env.REACT_APP_ADMIN_EMAIL || DEFAULT_EMAIL
).trim().toLowerCase();
const expectedPassword = process.env.REACT_APP_ADMIN_PASSWORD || DEFAULT_PASSWORD;

export const adminUsesDefaultCredentials = () =>
    !process.env.REACT_APP_ADMIN_EMAIL || !process.env.REACT_APP_ADMIN_PASSWORD;

export const adminExpectedEmail = () => expectedEmail;

export const verifyAdminCredentials = (email, password) => {
    const e = String(email || "").trim().toLowerCase();
    const p = String(password || "");
    return e === expectedEmail && p === expectedPassword;
};

export const isAdminGateOpen = () => {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
};

export const openAdminGate = () => {
    try {
        sessionStorage.setItem(STORAGE_KEY, "1");
    } catch { /* ignore */ }
};

export const closeAdminGate = () => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch { /* ignore */ }
};
